<template>
    <div class="product-center" >
        <div  v-for="item in product" :key="item.id">
            <div class="one">
                <h3><i class="iconfont icon-youjiantoushixinxiao"></i>{{item.title}}</h3>
                <ul>
                    <li v-for="(image, index) of item.images" :key="index"><img :src="$imgUrl+image" alt=""></li>
                </ul>
            </div>
            <div class="two">
                <h3><i class="iconfont icon-youjiantoushixinxiao"></i>功能模块</h3>
                <ul>
                    <li v-for="(fun,index) of item.name" :key="index">
                        <h5>{{fun}}</h5>
                        <p>{{item.account[index]}}</p>
                    </li>
                </ul>
            </div>
            <div class="three" v-if="item.case[0]||item.case[1]">
                <h3><i class="iconfont icon-youjiantoushixinxiao"></i>案例</h3>
                <ul>
                    <li v-for="(xg_case, index) in item.case" v-if="xg_case" :key="index">
                        <div class="img">
                            <img :src="$imgUrl+xg_case.photo" alt="">
                            <h4>{{xg_case.title}}</h4>
                        </div>
                    </li>
                    
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductCenter',
    props:{
        product: Array
    },
    mounted () {
        // console.log(this.props.product)
    },
    data () {
        return {
        }
    },
    methods: {
    },
    computed: {
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    @import '~styles/mixins.styl'
    .product-center
        width: 100%
        .iconfont
            color: #999
        .one
            padding: 6% 3% 3%
            background: #f6f6f6
            h3
                font-weight: 800
                font-size: 0.3rem
                margin: 0 0 1em
                i
                    font-size: 0.22rem
                    margin-right: 0.3em
                    vertical-align: middle
            ul
                overflow: hidden
                >li
                    float: left
                    width: 50%
                    img
                        width: 100%
        .two
            wdith: 100%
            h3
                padding: 6% 3% 3%
                font-weight: 800
                font-size: 0.3rem
                color: $black
                i
                    font-size: 0.22rem
                    margin-right: 0.3em
                    vertical-align: middle
            ul
                padding: 10% 8% 10% 5%
                background: $black
                li
                    padding-bottom: 4%
                    border-right: 1px solid #666
                    h5
                        font-family: MicrosoftYaHei
                        color: #fff
                        font-weight: 800
                        font-size: 0.32rem
                        margin-bottom: 0.3em
                        line-height: 1.4em
                    p
                        font-family: MicrosoftYaHei
                        text-indent: 0
                        font-size: 0.28rem
                        color: #ccc
                        font-weight: 600
                        line-height: 1.4em
                        padding-right: 2%
        .three
            padding: 6% 3% 20%
            background: #f6f6f6
            &:after
                content:''
                display: block
                clear:both
            h3
                font-weight: 800
                font-size: 0.32rem
                margin: 0 0 1em
                i
                    font-size: 0.22rem
                    margin-right: 0.3em
                    vertical-align: middle
            ul
                >li
                    position: relative
                    float: left
                    width: 44.5%
                    padding: 1.5% 2% 30%
                    background: $black
                    content: ''
                    display: block
                    .img
                        position: absolute
                        left: 3%
                        width: 94%
                        img
                            width: 100%
                        h4
                            text-align: center
                            font-size: 0.24rem
                            font-weight: 800
                            margin: 0.34rem 0 0.62rem
                            color: #353535
                >li:first-of-type
                    margin-right: 3%
</style>



// WEBPACK FOOTER //
// src/components/mobile/ProductCenter.vue